<template>
  <div class="import-product-fee-progress">
    <Modal v-model="visible" title="导入费率" :mask-closable="false" width="530" :closable="false" :footer-hide="true" class="my-modal progress-modal">
      <div class="close-btn" @click="close()" v-if="progress == 100">关闭</div>
      <div class="close-btn" @click="visible=false" v-else>缩小</div>
      <div class="info-box">
        <p>
          <span class="file-name">【{{ formData.fileName }}】</span>
          <span v-if="progress == 100">导入完成</span>
          <span v-else>导入处理中......</span>
        </p>
      </div>
      <Progress :percent="progress" status="active" v-if="progress != 100" />
      <div class="progress-text" v-if="formData.sumNum">
        <span v-if="progress != 100">导入在后台进行处理中，您可以点击缩小后正常进行其他操作</span>
        <span v-else-if="formData.failNum == '0' && formData.successNum != '0'">您的数据都已成功完整导入</span>
        <span v-else
          >已导入成功<span class="r">{{ formData.successNum }}</span
          >条，失败<span class="f">{{ formData.failNum }}</span
          >条<br />请下载异常文件后，修改您的异常数据再进行重新上传</span
        >
      </div>
      <p class="btn-box">
        <Button v-if="formData.failNum != 0 && formData.sumNum != 0 && progress == 100" type="error" class="btn-error" @click="downloadError()">下载异常数据</Button>
      </p>
    </Modal>

    <div class="import-small-list" v-if="visibleSmall && !visible">
      <div class="import-small">
        <div class="top-box">
          <div class="top-text">
            <img class="icon-status" v-if="progress != 100" src="@static/images/icon_waitting.png" alt="" />
            <img class="icon-status" v-else src="@static/images/icon_success.png" alt="" />
            <div>
              <tooltip :txtInfo="'[' + formData.fileName + ']'" v-if="formData.fileName.length > 20"></tooltip>
              <span v-else>[{{ formData.fileName }}]</span>
              <span v-if="progress != 100">导入处理中...</span>
              <span v-else-if="formData.failNum">导入完成！</span>
              <span v-else>导入成功！</span>
            </div>
          </div>
          <div class="btn-box">
            <img class="top-btn" v-if="progress == 100" @click="close()" src="@static/images/icon_close.png" alt="" />
          </div>
        </div>
        <div class="progress-text" v-if="formData.sumNum">
          <span v-if="progress != 100">导入在后台进行处理中，您可以正常进行其他操作</span>
          <span v-else-if="formData.failNum == '0' && formData.successNum != '0'">您的数据都已成功完整导入</span>
          <span v-else
            >已导入成功<span class="r">{{ formData.successNum }}</span
            >条，失败<span class="f">{{ formData.failNum }}</span
            >条<br />请下载异常文件后，修改您的异常数据再进行重新上传</span
          >
        </div>
        <Progress v-if="progress != 100" :percent="progress" status="active" />
        <p class="notice" v-if="progress != 100">
          成功<span class="r">{{ formData.successNum }}</span
          >条，失败<span class="f">{{ formData.failNum }}</span
          >条
        </p>
        <div style="text-align: center; margin-top: 4px" v-if="formData.exceptionUrl">
          <Button v-if="formData.failNum !=0 && formData.sumNum != 0 && progress == 100" type="error" class="btn-error" @click="downloadError()">下载异常数据</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      progress: 0,
      visible: false,
      visibleSmall: false,
      formData: {},
      timer: {}
    };
  },
  watch: {},
  computed: {},
  mounted() {},
  deactivated(){
    console.log('deactivated')
    window.clearTimeout(this.timer);
  },
  beforeDestroy() {
    console.log('beforeDestroy')
    window.clearTimeout(this.timer);
  },
  methods: {
    open(showBig = false) {
      this.visible = showBig;
      this.progress = 0;
      this.getData();
    },
    start() {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(this.getData, 5000);
    },
    getData() {
      this.$http({
        url: '/buz/commission/config/importResult',
        type: 'POST',
        data: {}
      }).then(res => {
        const data = res.data;
        if(data.delFlag) {
          data.sumNum = 0;
        }
        if (data.sumNum != 0) {
          this.visibleSmall = true;
          if(data.uploadFlag) {
            this.progress = 100;
          }else{
            this.progress = ((data.successNum*1 + data.failNum*1) / data.sumNum * 100).toFixed(0) * 1;
          }
          this.formData = data;
          if (!data.uploadFlag) {
            this.start();
          }
        } else {
          this.visibleSmall = false;
        }
      });
    },
    // 下载异常
    downloadError() {
      if(!this.formData.exceptionUrl) {
        this.$notice.msg('异常文件链接不存在');
        return
      }
      location.href = this.formData.exceptionUrl;
    },
    // 关闭完成的任务
    close(){
      this.$emit('success');
      this.$http({
        url: '/buz/commission/config/importResult',
        type: 'POST',
        data: {
          delFlag: true
        }
      }).then(res => {
        this.visibleSmall = false;
        this.visible = false;
      })
    }
  }
};
</script>
<style lang="scss" scoped>
@import './progressModal.scss';
</style>
